import React from "react";
import PropTypes from "prop-types";
import TwoPaneMultiSelectContainer
    from "lib/common/twopanemultiselect/TwoPaneMultiSelectContainer";
import asModal from "lib/modal/asModal";

export const Wrapper = ({
                                   triggerClose,
                                   triggerSave,
                               }) =>
    <TwoPaneMultiSelectContainer
        triggerClose={triggerClose}
        triggerSave={triggerSave}
        contentBlocks={{
            header: "Please select the fields you would like to exclude from the Validation and DQR Results.",
            unselectedPane: "Available Fields For Exclusion",
            selectIcon: "Exclude",
            selectedPane: "Excluded Fields",
            unselectIcon: "Don't Exclude",
        }}
    />;

Wrapper.propTypes = {
    triggerClose: PropTypes.func.isRequired,
    triggerSave: PropTypes.func.isRequired,
};

export default asModal("Manage Validation Configuration")(Wrapper);



// WEBPACK FOOTER //
// ./app/lib/validationFilter/ValidationFilterModal.js